import { Building as ApiBuilding } from '../realty/model/Building';
import { SeparatelyOccupiedUnit as ApiUnit } from '../realty/model/SeparatelyOccupiedUnit';
import { Unit } from './Unit';
import { ApiDate } from '../realty/model/ApiDate';
import { defined, evaluate } from '../utility/Control';
import { CulturalHeritage } from '../realty/model/CulturalHeritage';
import { BuildingChange } from '../realty/model/BuildingChange';

const RESIDENTIAL_BUILDING_CODE_INTERVAL_LOWERBOUND = 100;
const RESIDENTUAL_BUILDING_CODE_INTERVAL_UPPERBOUND = 179;

export class Building {
  public typeOfBuilding: string;
  public isResidential: boolean;
  public usedDate: ApiDate;
  public totalFloorSpace: number;
  public culturalHeritages: CulturalHeritage[] = [];
  public buildingChanges: BuildingChange[] = [];
  public units: Unit[] = [];
  public numberOfDwellings = 0;
  public numberOfRooms = 0;
  public numberOfWCs = 0;
  public numberOfBathRooms = 0;

  public static isResidential(apiBuilding: ApiBuilding): boolean {
    const code = parseInt(apiBuilding.typeOfBuilding.code, 10);
    return (
      code >= RESIDENTIAL_BUILDING_CODE_INTERVAL_LOWERBOUND && code <= RESIDENTUAL_BUILDING_CODE_INTERVAL_UPPERBOUND
    );
  }

  public constructor(apiBuilding: ApiBuilding) {
    this.typeOfBuilding = apiBuilding.typeOfBuilding.text;
    this.isResidential = Building.isResidential(apiBuilding);
    this.usedDate = apiBuilding.usedDate;
    this.totalFloorSpace = apiBuilding.totalFloorSpace; // FIXME: Should be sum of areas from units??
    this.culturalHeritages = evaluate(apiBuilding, 'inclusions.culturalheritages.items');
    this.buildingChanges = evaluate(apiBuilding, 'inclusions.buildingchanges.items');
    const apiUnits: ApiUnit[] = evaluate(apiBuilding, 'inclusions.units.items');
    if (defined(apiUnits)) {
      apiUnits.forEach((apiUnit: ApiUnit) => {
        this.addUnit(new Unit(apiUnit));
      });
    }
  }

  public addUnit(unit: Unit): void {
    this.units.push(unit);
    if (unit.isDwelling) {
      ++this.numberOfDwellings;
    }
    this.numberOfRooms += unit.numberOfRooms;
    this.numberOfWCs += unit.numberOfWCs;
    this.numberOfBathRooms += unit.numberOfBathRooms;
    // TODO: Increase total floorspace by unit area?
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/Building.ts
 **/